export const START_ROUTE_PATH = 'start'

export const DOCUMENTS_ROUTE_PATH = 'documents'
export const AUTOGIRO_ROUTE_PATH = 'autogiro'
export const LETTER_ROUTE_PATH = 'brev'
export const LOAN_ROUTE_PATH = 'låna'
export const KYC_ROUTE_PATH = 'kundkännedom'
